/**
 * MfaSetupScreen - UI Layer
 * Pantalla bloqueante a pantalla completa: el usuario debe enrolar su segundo factor.
 * El enrolamiento MFA se delega al perfil de RBAC (webapp de cuenta), abierto en otra pestaña.
 */

import { Button } from '@/components/ui/Button';

interface MfaSetupScreenProps {
  onLogout?: () => void;
}

export function MfaSetupScreen({ onLogout }: MfaSetupScreenProps) {
  const openMfaSetup = () => {
    window.open(
      `${import.meta.env.VITE_ACCOUNT_URL}/me/security/mfa-setup`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        padding: '1.5rem',
        textAlign: 'center',
      }}
    >
      <h1>Configurá tu segundo factor</h1>
      <p>
        Para continuar necesitás activar la verificación en dos pasos (MFA) en tu
        cuenta.
      </p>
      <Button onClick={openMfaSetup}>Configurar en mi perfil</Button>
      {onLogout && (
        <Button variant="ghost" onClick={onLogout}>
          Cerrar sesión
        </Button>
      )}
    </div>
  );
}
